import auth from './auth'
import user from './user'
import dom from './dom'
import toast from './toast'
import news from './news'
import profilePosts from './profilePosts'
import project from './project'
import bot from './bot'

export default {
  auth,
  user,
  dom,
  toast,
  news,
  profilePosts,
  project,
  bot
}
